<app-widget [name]="'sla-alarms'" [header]="'Health of SLA Resources'" [isWorking]="isLoading" [refreshFunc]="refresh" [refreshRatesInMinutes]="[1,2,3,4,5]" [actions]="actions">

  <div class="tw-flex tw-flex-col tw-items-start tw-justify-normal tw-gap-2">
    <h3>
      <span class="greenAlarm">OK: {{greenAlarms?.length}}</span>
      <span>&nbsp;</span>
      <span class="redAlarm">ALARM: {{redAlarms?.length}}</span>
      <span>&nbsp;</span>
      <span class="pendingAlarm">PENDING: {{pendingAlarms?.length}}</span>
    </h3>

    <div *ngIf="redAlarms?.length == 0">
      ✅ All alarms are OK.
    </div>

    <div *ngFor="let alarm of redAlarms">
      🔥 {{alarm.alarmName}}
    </div>
  </div>

</app-widget>